import { useState } from "react"
import { useMap } from "react-leaflet"

import Icon from "../Icon"

export const ZOOM_DELTA = 0.25
const MAX_ZOOM = 100
const MIN_ZOOM = -MAX_ZOOM

// requires a leaflet map provider. See "useMap"
export const ZoomControl = () => {
  const map = useMap()
  const [zoomCount, setZoomCount] = useState<number>(0)
  const zoomOutDisabled = zoomCount < MIN_ZOOM
  const zoomInDisabled = zoomCount > MAX_ZOOM
  const zoomIn = () => {
    setZoomCount((z) => z + ZOOM_DELTA)
    map.zoomIn(ZOOM_DELTA)
  }
  const zoomOut = () => {
    setZoomCount((z) => z - ZOOM_DELTA)
    map.zoomOut(ZOOM_DELTA)
  }
  return (
    <div className="mx-4 my-4 leaflet-top leaflet-right">
      <div className="leaflet-control flex flex-col">
        <button
          className={`h-8 w-8 bg-white shadow-xxs ${
            zoomInDisabled ? "bg-gray-200" : "bg-white"
          }`}
          onClick={() => zoomIn()}
          disabled={zoomInDisabled}
        >
          <Icon icon="plus" size="xxs" className="m-auto" />
        </button>
        <button
          className={`h-8 w-8 bg-white shadow-xxs mt-2 ${
            zoomOutDisabled ? "bg-gray-200" : "bg-white"
          }`}
          onClick={() => zoomOut()}
          disabled={zoomOutDisabled}
        >
          <Icon icon="minus" size="xxs" className="m-auto" />
        </button>
      </div>
    </div>
  )
}
